module.exports = __webpack_public_path__ + "img/vertical_6_5_8023.3cbbd2b1.png";